import { ProductVariant } from '@commerce/types/product'
import Image from 'next/image'
import Link from 'next/link'
import React, { useEffect, useState } from 'react'
import icoSetting from '@publicAssets/images/ui/step/ico-setting-ring.svg'
import step2 from '@publicAssets/images/ui/step/step-2.svg'
import step1 from '@publicAssets/images/ui/step/step-1.svg'
import { useRouter } from 'next/router'
import { formatUSDollar } from '@utils/format-price'
// Image loader
import { imageLoader } from '@utils/image-loader'

const StepSetting: React.FC<{
  active?: boolean
  choosing: boolean
  chosen: boolean
  startWith?: 'setting' | 'diamond' | string
  productData?: Partial<ProductVariant>
}> = ({ active, choosing, chosen, productData, startWith }) => {
  const [isChosen, setIsChosen] = useState(true)
  const [linkView, setLinkView] = useState('')
  const placeholderImg = '/product-img-placeholder.svg'
  const router = useRouter()
  const { pathname } = useRouter()
  let myPath: String[] = pathname.split('/')

  const handleDeleteSetting = () => {
    if (typeof window !== 'undefined') {
      try {
        const storedSetting = window.localStorage.getItem('setting')
        const storedModifiedCombination = window.localStorage.getItem(
          'modified-combination'
        )
        if (storedSetting && storedModifiedCombination) {
          const setting = JSON.parse(storedSetting) as ProductVariant
          const modifiedCombination: {
            itemId: string | number
            groupId: number
          } = JSON.parse(storedModifiedCombination)
          const { itemId } = modifiedCombination

          if (!itemId) {
            window.localStorage.removeItem('modified-combination')
          }
          // Remove the stored modified-combination in case the customer is reassembling a setting-diamond combination but wants to change the setting.
          if (setting.id == itemId) {
            window.localStorage.removeItem('modified-combination')
          }
          window.localStorage.removeItem('setting')
        } else {
          window.localStorage.removeItem('setting')
          window.localStorage.removeItem('modified-combination')
        }
      } catch (error) {
        window.localStorage.removeItem('setting')
        window.localStorage.removeItem('modified-combination')
      }
    }
  }

  useEffect(() => {
    if (productData && productData.slug) {
      setLinkView(productData.slug)
    }
  }, [productData])

  const isPage = () => {
    console.log(pathname)
    if (pathname.includes('/product/')) {
      router.push('/t/create-your-ring')
    } else {
      router.reload()
    }
  }

  return (
    <>
      {active ? (
        <div className="flex flex-1 flex-row justify-between bg-white">
          <div className="relative flex justify-center items-center w-full flex-row md:justify-around lg:px-4 lg:justify-between lg:gap-3 mmd:gap-2">
            {startWith === 'diamond' ? (
              <div className="md:w-[19px] md:h-[25px] w-[9px] h-4 relative">
                <Image
                  src={step2}
                  alt={'Step 2'}
                  objectFit="contain"
                  layout="fill"
                  className="absolute top-[-20px] md:top-0"
                />
              </div>
            ) : (
              <div className="md:w-[19px] md:h-[25px] w-[5px] h-4 relative">
                <Image
                  src={step1}
                  alt={'Step 1'}
                  objectFit="contain"
                  layout="fill"
                  className="absolute top-[-20px] md:top-0"
                />
              </div>
            )}
            <div className="flex flex-col items-start">
              <Link href="/t/create-your-ring">
                <a className="inline-flex flex-col leading-5">
                  <h2 className="capitalize text-xs md:text-base hover:underline font-semibold text-gray-dark leading-5">
                    Setting
                  </h2>
                  {!productData && (
                    <span className="text-xs font-normal mlg:hidden text-gray-dark">
                      Choose your Setting
                    </span>
                  )}
                </a>
              </Link>
            </div>
            {choosing ? (
              <div className="flex flex-col items-center gap-2 min-h-[53px] md:flex-row-reverse msm:mt-1 mmd:hidden">
                <Image
                  src={icoSetting}
                  alt={'Setting active icon'}
                  width={33}
                  height={33}
                />
                {myPath.includes('[slug]') && (
                  <Link href="/t/create-your-ring">
                    <a className="text-xs text-gray-dark hover:underline md:text-sm">
                      Change
                    </a>
                  </Link>
                )}
              </div>
            ) : (
              <>
                {isChosen ? (
                  <div className="flex flex-col-reverse items-center md:flex-row md:gap-4 mmd:hidden">
                    <div className="flex flex-col items-end min-h-20px">
                      <div className="hidden text-sm text-gray-dark font-semibold md:block">
                        {productData && productData.price && (
                          <p>{formatUSDollar(productData.price.value)}</p>
                        )}
                      </div>
                      <div className="flex text-xs">
                        <Link href={linkView ? `/product/${linkView}` : '/t/create-your-ring'}>
                            <a className="hidden text-xs text-gray-dark hover:underline md:block">
                                View
                            </a>
                        </Link>
                        <span className="hidden text-xs text-gray-dark hover:underline md:block ml-1">
                          |
                        </span>
                        <Link href="/t/create-your-ring">
                          <a
                            className="text-xs mx-[2px] text-gray-dark hover:underline"
                            onClick={() => {
                              handleDeleteSetting()
                              isPage()
                            }}
                          >
                            Change
                          </a>
                        </Link>
                      </div>
                    </div>
                    {productData &&
                    productData.images &&
                    productData.images.length > 0 ? (
                      <Link href={`/product/${linkView}`}>
                        <a className="relative block w-8 h-8">
                          <Image
                            loader={imageLoader}
                            src={productData.images[0].url}
                            alt={productData.images[0].alt}
                            layout="fill"
                            objectFit="cover"
                            className="rounded"
                          />
                        </a>
                      </Link>
                    ) : (
                      <Link href={`/product/${linkView}`}>
                        <a className="relative block w-8 h-8">
                          <Image
                            src={placeholderImg}
                            alt={'Default image'}
                            layout="fill"
                            objectFit="cover"
                            className="rounded"
                          />
                        </a>
                      </Link>
                    )}
                  </div>
                ) : (
                  <div className="mb-1 md:mb-0 msm:mt-1 mmd:hidden">
                    <Image
                      src={icoSetting}
                      alt={'Setting icon'}
                      width={30}
                      height={25}
                    />
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      ) : (
        <div className="flex flex-1 flex-row justify-between bg-gray-100">
          <div className="relative flex justify-center items-center w-full flex-row md:justify-around lg:px-4 lg:justify-between lg:gap-3 mmd:gap-2">
            {startWith === 'diamond' ? (
              <div className="md:w-[19px] md:h-[25px] w-[9px] h-4 relative">
                <Image
                  src={step2}
                  alt={'Step 2'}
                  objectFit="contain"
                  layout="fill"
                  className="absolute top-[-20px] md:top-0"
                />
              </div>
            ) : (
              <div className="md:w-[19px] md:h-[25px] w-[5px] h-4 relative">
                <Image
                  src={step1}
                  alt={'Step 1'}
                  objectFit="contain"
                  layout="fill"
                  className="absolute top-[-20px] md:top-0"
                />
              </div>
            )}
            <div className="flex flex-col items-start ">
              {productData ? (
                <Link href="/t/create-your-ring">
                  <a className="inline-flex flex-col leading-5">
                    <h2 className="capitalize text-xs md:text-base hover:underline font-semibold text-gray-dark leading-5">
                      Setting
                    </h2>
                  </a>
                </Link>
              ) : (
                <Link href="/t/create-your-ring">
                  <a className="inline-flex flex-col">
                    <h2 className="capitalize text-xs md:text-base hover:underline font-semibold text-gray-dark leading-5">
                      Setting
                    </h2>
                    <p className="text-xs font-normal mlg:hidden text-gray-dark mmd:hidden">
                      Choose your Setting
                    </p>
                  </a>
                </Link>
              )}
            </div>
            {choosing ? (
              <div className="flex items-center msm:mt-1 mmd:hidden">
                <Image
                  src={icoSetting}
                  alt={'Setting icon'}
                  width={27}
                  height={29}
                />
              </div>
            ) : (
              <>
                {isChosen ? (
                  <div className="flex flex-col-reverse items-center md:flex-row md:gap-4 mmd:hidden">
                    <div className="flex flex-col items-end">
                      <div className="hidden text-sm text-gray-dark font-semibold md:block">
                        {productData && productData.price && (
                          <p>{formatUSDollar(productData.price.value)}</p>
                        )}
                      </div>
                      <div className="flex flex-row text-xs">
                        <Link href={linkView ? `/product/${linkView}` : '/t/create-your-ring'}>
                            <a className="hidden text-xs text-gray-dark hover:underline md:block">
                                View
                            </a>
                        </Link>
                        <span className="hidden text-xs text-gray-dark hover:underline md:block ml-1">
                          |
                        </span>
                        <Link href="/t/create-your-ring">
                          <a
                            className="text-xs ml-[2px] text-gray-dark hover:underline"
                            onClick={handleDeleteSetting}
                          >
                            Change
                          </a>
                        </Link>
                      </div>
                    </div>
                    {productData &&
                    productData.images &&
                    productData.images.length > 0 ? (
                      <Link href={`/product/${linkView}`}>
                        <a className="relative block w-8 h-8">
                          <Image
                            loader={imageLoader}
                            src={productData.images[0].url}
                            alt={productData.images[0].alt}
                            layout="fill"
                            objectFit="cover"
                            className="rounded"
                          />
                        </a>
                      </Link>
                    ) : (
                      <Link href={`/product/${linkView}`}>
                        <a className="relative block w-8 h-8">
                          <Image
                            src={placeholderImg}
                            alt={'Default image'}
                            layout="fill"
                            objectFit="cover"
                            className="rounded"
                          />
                        </a>
                      </Link>
                    )}
                  </div>
                ) : (
                  <div className="mb-4 md:mb-0 flex items-center msm:mt-1 mmd:hidden">
                    <Image
                      src={icoSetting}
                      alt={'Setting icon'}
                      width={27}
                      height={29}
                    />
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}
    </>
  )
}

export default StepSetting
